import { Enviadas } from "./Enviadas/Enviadas"

export const FacturasProforma = () => {
  return (
    <main className='tw-flex tw-flex-col tw-order-2 tw-z-10 tw-relative tw-w-full tw-max-h-screen tw-h-full tw-bg-gray tw-overflow-x-hidden tw-overflow-y-hidden custom-scrollbar'>
      <Enviadas />
    </main>
  )
}
